export default "__VITE_ASSET__BU2gtB63__"